export { ProductCard } from './product-card';
